<article class="flex ps-medium-b ps-medium-l ps-medium-t ps-medium-r" [ngClass]="styleClasses$ | async">
  <div class="icon-container ms-small-r flex flex--center">
    <fcom-icon *ngFor="let icon of icons$ | finObsToArray" [name]="icon | async" class="icon-large" />
  </div>
  <div class="text-container flex flex--center">
    <div [innerHTML]="content$ | async | finSafe: 'html'"></div>
  </div>
</article>
